import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";
import {SpineUtils} from "../../utils/SpineUtils";

/**
 * Created by Jerker Nord on 2022-10-24.
 */

export class BenjiKIVRespinTriggeredView extends PIXI.Container implements StageLayer {

    private static SPINE_ANIMATION_NAME:string = "Respin";

    private _background:PIXI.Sprite;
    private _reSpinSpine:PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "BenjiKIVNormalRespinView";
        this.init();
    }

    private init():void {
        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.tint = 0x000000;
        this._background.alpha = 0;
        this.addChild(this._background);

        this._reSpinSpine = new PIXI.spine.Spine(BenjiKIV.assetLoader.getSpineAsset(BenjiKIVGameAssets.RESPIN_SPINE));
        this._reSpinSpine.position.set(360, 360);
        this._reSpinSpine.visible = false;
        this.addChild(this._reSpinSpine);

        this.onResize();
    }

    public getNormalRespinAnimation():gsap.core.Timeline {
        const mainTL:gsap.core.Timeline = gsap.timeline();
        mainTL.add([
            () => BenjiKIV.soundPlayer.playSound(BenjiKIVSound.RESPIN_SPLASH),
            gsap.to(this._background, {duration : 0.2, alpha : 0.7}),
            () => {
                this._reSpinSpine.visible = true;
                SpineUtils.resetSpineAnimation(this._reSpinSpine);

                // #175
                BenjiKIV.xBetView.stopXBetBlueReelOverlay();
            }
        ]);
        mainTL.add(new SpineTween(this._reSpinSpine, 0, BenjiKIVRespinTriggeredView.SPINE_ANIMATION_NAME));
        mainTL.add([
            gsap.to(this._background, {duration : 0.2, alpha : 0}),
            () => {this._reSpinSpine.visible = false}
        ]);
        return mainTL;
    }

    public onResize():void {
        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
        this._background.x = NolimitApplication.screenBounds.left;
        this._background.y = NolimitApplication.screenBounds.top;
    }
}